module.exports = __webpack_public_path__ + "img/password_saved.88367072.svg";